import {
    Box,
    Button
} from "@mui/material"

import { Location } from "../../models";
import SimpleLocationCard from "../../componentsV2/location/SimpleLocationCard"

export type TPossibleDuplicateLocationsListItem = {
    readonly item: Location;
    readonly isCurrentSelection: boolean;
    readonly onClick: () => void;
}

export const PossibleDuplicateLocationsListItem = ({ item, onClick, isCurrentSelection }: TPossibleDuplicateLocationsListItem) => {

    return (
        <Box
            sx={{
                width: "100%",
                border: isCurrentSelection ? "2px solid black" : "none"
            }}
        >
            <Button
                fullWidth
                sx={{
                    "& > div": {
                        width: "100%", // to make the button look full width even with small text
                    },
                }}
                onClick={onClick}
            >
                <SimpleLocationCard
                    location={item}
                    onClick={onClick}
                />
            </Button>
        </Box>
    );
}